"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class ExpressionInternalApi extends ApiBase_1.ApiBase {
    /**
     * Checks if a column is referenced in a given Expression
     * @param columnId Column to Check
     * @param expression Expression to Lookup
     */
    isColumnReferencedInExpression(columnId, expression) {
        const colIds = this.getExpressionApi().getColumnsFromExpression(expression);
        return colIds.some((c) => c === columnId);
    }
    evaluateExpressionInAdaptableQL(module, object, expression) {
        var _a;
        const evaluateExpressionExternallyFn = (_a = this.getExpressionOptions()) === null || _a === void 0 ? void 0 : _a.evaluateAdaptableQLExternally;
        if (typeof evaluateExpressionExternallyFn !== 'function') {
            return true;
        }
        const context = {
            adaptableApi: this.getAdaptableApi(),
            userName: this.getOptions().userName,
            adaptableId: this.getOptions().adaptableId,
            module,
        };
        if (object) {
            context.object = object;
        }
        if (expression) {
            context.expression = expression;
            context.referencedColumns = this.getAdaptableApi()
                .expressionApi.getColumnsFromExpression(expression)
                .map((columnId) => this.getAdaptableApi().columnApi.getColumnWithColumnId(columnId));
        }
        return !evaluateExpressionExternallyFn(context);
    }
    evaluatePredicatesInAdaptableQL(module, object, predicates) {
        var _a;
        const evaluateExpressionExternallyFn = (_a = this.getExpressionOptions()) === null || _a === void 0 ? void 0 : _a.evaluateAdaptableQLExternally;
        if (typeof evaluateExpressionExternallyFn !== 'function') {
            return true;
        }
        const context = {
            adaptableApi: this.getAdaptableApi(),
            userName: this.getAdaptableApi().optionsApi.getUserName(),
            adaptableId: this.getAdaptableApi().optionsApi.getAdaptableId(),
            module,
        };
        if (object) {
            context.object = object;
        }
        if (predicates) {
            context.predicates = predicates;
            // need to find a way to get the columns in the predicates
            // cand do later
            //        this.getAdaptableApi().scopeApi.getColumnsForScope();
        }
        return !evaluateExpressionExternallyFn(context);
    }
}
exports.ExpressionInternalApi = ExpressionInternalApi;
